// Shrink
function shrink() {

    console.log('shrink');

    const navItems = document.querySelectorAll('#navigation .menu-item a');

    var offset = 150;
    var duration = 300;
    window.addEventListener('scroll', function () {
        if (window.scrollY > offset) {
            document.body.classList.add('shrink');
        } else {
            document.body.classList.remove('shrink');
        }
    });

}

export default shrink;
